import PushesPage from './PushesPage';

export default PushesPage;
